angular.module("app.modalControllers").controller("ConfirmWithCommentModalController", [
    '$scope',
    '$uibModalInstance',
    'text',
    function ($scope, $modalInstance, text) {
        var formElement;
        $scope.text = text;
        $scope.tooltip = {
            comment: ""
        };

        $scope.init = function (form) {
            formElement= form;
            $scope.comment = "";

        };


        $scope.ok = function () {
            $scope.isSavePressed = true;
            if (formElement.$valid) {
                $modalInstance.close($scope.comment);
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);